// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html

import * as actions from "../../../_redux/franchises/franchisesActions";
import * as uiHelpers from "../FranchisesUIHelpers";

import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  getHandlerTableChange,
  getSelectRow,
  sortCaret,
} from "../../../../../../_metronic/_helpers";
import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import NoRecord from "../../../../../../_metronic/_partials/widgets/NoRecord";
import { BootstrapTable, Pagination, PaginationProvider, paginationFactory } from "../../../../../../_metronic/_partials/controls";
import { useFranchisesUIContext } from "../FranchisesUIContext";
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";

export function FranchisesTable() {
  const intl = useIntl();
  let navigate = useNavigate();

  // Products UI Context
  const franchisesUIContext = useFranchisesUIContext();
  const franchisesUIProps = useMemo(() => {
    return {
      ids: franchisesUIContext.ids,
      setIds: franchisesUIContext.setIds,
      queryParams: franchisesUIContext.queryParams,
      setQueryParams: franchisesUIContext.setQueryParams,
    };
  }, [franchisesUIContext]);

  // Getting curret state of products list from store (Redux)
  const { currentState, permission } = useSelector(
    (state) => ({
      currentState: state.franchise.list,
      permission: state.auth.permission,
    }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  // Products Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    // clear selections list
    franchisesUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchFranchises(franchisesUIProps.queryParams));
    return () => {
      dispatch(actions.resetStateFranchise());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [franchisesUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    {
      dataField: "franchise_reference_id",
      text: intl.formatMessage({ id: "FRANCHISE.ID" }),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "name",
      text: intl.formatMessage({ id: "FRANCHISE.NAME" }),
      sort: true,
      sortCaret: sortCaret,
    },

    {
      dataField: "short_name",
      text: intl.formatMessage({ id: "FRANCHISE.SHORT" }),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "phone",
      text: intl.formatMessage({ id: "PHONE" }),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "email",
      text: intl.formatMessage({ id: "EMAIL" }),
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "plan_type",
      text: "Plan type",
      // sort: true,
      // sortCaret: sortCaret,
      formatter: (e, data) => {
        const capitalizedArray = e?.map(
          (item) => item.charAt(0).toUpperCase() + item.slice(1)
        );
        return <span>{capitalizedArray?.join(", ") || "-"}</span>;
      },
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: franchisesUIProps.queryParams.pageSize,
    page: franchisesUIProps.queryParams.pageNumber,
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      navigate(`/settings/franchises/franchise-details/${row.id}`);
    },
  };
  // const rowEvents = {
  //   onClick: (e, row, rowIndex) => {
  //     // navigate(`/settings/promotions/promotions-details/${url}`);
  //     window.open(`franchises/franchise-details/${row.id}`, "_blank");
  //   },
  // };
  const selectRow = {
    mode: "checkbox",
    hideSelectAll: true,
    hideSelectColumn: true,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
              entities={entities}
            >
              <BootstrapTable
                rowEvents={rowEvents}
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                selectRow={
                  permission?.setting_franchise?.delete
                    ? getSelectRow({
                        entities,
                        ids: franchisesUIProps.ids,
                        setIds: franchisesUIProps.setIds,
                      })
                    : selectRow
                }
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  franchisesUIProps.setQueryParams
                )}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>

              {(entities && entities?.length) || listLoading ? (
                ""
              ) : (
                <NoRecord />
              )}
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
